.logoClickable:hover {
  cursor: pointer;
}
